import { Mic, Image as ImageIcon } from 'lucide-react';

export default function ModeSelector({ onSelect }) {
  return (
    <div className="bg-background/95 backdrop-blur-sm border border-border rounded-3xl p-10 shadow-2xl flex flex-col items-center z-20">
      <p className="text-base text-muted-foreground mb-8">Выберите способ ответа для пациента:</p>
      <div className="flex gap-6">
        <button onClick={() => onSelect('say')} className="flex flex-col items-center gap-3 p-8 bg-secondary rounded-2xl hover:bg-accent/10 hover:border-accent border border-transparent transition-colors">
          <Mic className="size-10 text-primary" /><span className="text-base font-semibold text-primary">Сказать</span>
        </button>
        <button onClick={() => onSelect('show')} className="flex flex-col items-center gap-3 p-8 bg-secondary rounded-2xl hover:bg-accent/10 hover:border-accent border border-transparent transition-colors">
          <ImageIcon className="size-10 text-primary" /><span className="text-base font-semibold text-primary">Показать</span>
        </button>
      </div>
    </div>
  );
}